import React from 'react'
import "./Services.css"

const Services = () => {
    return (


        <>

            <section id='services'>
                <div className="container-fluid">
                    {/* <div className="container"> */}
                    <div className="CommonPadding">
                        <div className="row d-flex justify-content-center align-items-center Organic-Food-Section-Main-Heading-Top">
                            <div className='Home-Our-Services-Section-Title'>
                                <h5>
                                    Our Services
                                </h5>
                                <h2>
                                    Enhancing your beauty with expertise and elegance
                                </h2>
                            </div>
                        </div>

                        <div className="row g-4">
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/UpSer1.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Facial & Clean-up Services </li>
                                            <li> Basic Clean-up </li>
                                            <li> Fruit Facial </li>
                                            <li> Herbal Facial </li>
                                            <li> Gold Facial </li>
                                            <li> Diamond Facial </li>
                                            <li> Pearl Facial </li>
                                            <li> Charcoal Facial </li>
                                            <li> D-Tan facial </li>
                                            <li> Skin Whitening Facial </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/HomeService9.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Hair Care & Styling  </li>
                                            <li> Hair Cut  </li>
                                            <li> Hair Wash & Conditioning </li>
                                            <li> Hair Spa & Smoothening </li>
                                            <li> Keratin Treatment </li>
                                            <li> Hair Botox & Hair Oil Massage </li>
                                            <li> Hair Coloring (Global / Highlights) </li>
                                            <li> Root Touch-up </li>
                                            <li> Blow Dry / Ironing / Curls </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/HomeService3.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li>  Hand & Feet Care </li>
                                            <li> Manicure (Basic / Spa) </li>
                                            <li> Pedicure (Basic / Spa) </li>
                                            <li> Nail Cutting & Shaping </li>
                                            <li> Nail Art </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/UpSer4.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Body Care </li>
                                            <li> Head massage </li>
                                            <li> Body Massage  </li>
                                            <li> Body polishing </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/UpSer5.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Bleach & D-Tan </li>
                                            <li> Face Bleach </li>
                                            <li> Neck Bleach </li>
                                            <li> Arms / Legs Bleach </li>
                                            <li> Full Body Bleach </li>
                                            <li> Face D-Tan </li>
                                            <li> Hands & Legs D-Tan </li>
                                            <li> Full Body D-Tan </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/UpSer6.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Makeup & Grooming </li>
                                            <li> Simple / Daily Makeup </li>
                                            <li> Party Makeup </li>
                                            <li> Engagement Makeup </li>
                                            <li> Bridal Makeup </li>
                                            <li> Reception Makeup </li>
                                            <li> Saree Draping </li>
                                            <li> Hair Styling </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/HomeService6.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li> Threading & Waxing </li>
                                            <li> Eyebrow Threading </li>
                                            <li> Upper Lip / Chin / Forehead / <br /> Full Face Threading </li>
                                            <li> Face Waxing </li>
                                            <li> Underarms Waxing </li>
                                            <li> Full Hand Waxing </li>
                                            <li> Half Legs / Full Legs Waxing </li>
                                            <li> Bikini Wax </li>
                                            <li> Full Body Wax </li>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                <div className="image HoverEffect ">
                                    <img className='w-100' src={require("../Img/UpSer8.jpg")} alt="" />
                                    <div className='content'>
                                        <p>
                                            <li style={{listStyle:"none",paddingLeft:"0px",fontSize:"20px",fontWeight:"600"}}> Courses   </li>
                                            <li> Basic Parlor cources  </li>
                                            <li> Advanced Parlor Cources </li>
                                            <li> Hair cut & Hair treatment cources </li>
                                            <li> Professional makeup artist & Hair <br /> Stylist cources </li>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </section>

        </>
    )
}

export default Services